import React from 'react'

export default class Verificacao extends React.Component {
    render() {
        return (
            <React.Fragment>
                <div className="mt-5 font-weight-bold text-left">
                    3 - MOTIVO DA VERIFICAÇÃO:
                </div>
                <div className="form-group row mt-3 text-left">
                    <label className="col-3 col-md-2">Denúncia:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="denuncia"
                            {...this.props}
                            value={this.props.value.denuncia} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    {this.renderDenuncia()}
                    <label className="col-6 col-md-3">Foi anexada mídia(s) a denúncia:</label>
                    <div className="col-6 col-md-3 mb-3">
                        <select className="custom-select"
                            name="midia"
                            {...this.props}
                            value={this.props.value.midia} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                        </select>
                    </div>
                    <label className="col-6 col-md-3">a. O conteúdo denunciado continua sendo divulgado na rede social?</label>
                    <div className="col-6 col-md-3 mb-3">
                        <select className="custom-select"
                            name="divulgacao"
                            {...this.props}
                            value={this.props.value.divulgacao} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                            <option value="Parcialmente">Parcialmente</option>
                        </select>
                    </div>
                    <label className="col-6 col-md-3">b. Trata-se de publicação que expira com tempo determinado?</label>
                    <div className="col-6 col-md-3 mb-3">
                        <select className="custom-select"
                            name="expira"
                            {...this.props}
                            value={this.props.value.expira} >
                            <option value=""></option>
                            <option value="Sim">Sim</option>
                            <option value="Não">Não</option>
                            <option value="Parcialmente">Parcialmente</option>
                        </select>
                    </div>
                    <label className="col-3 col-md-2">Verificação:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="verificacao"
                            {...this.props}
                            value={this.props.value.verificacao} >
                            <option value=""></option>
                            <option value="de Adequação">de Adequação</option>
                            <option value="de Rotina">de Rotina</option>
                            <option value="por Denúncia">por Denúncia</option>
                        </select>
                    </div>
                    {this.renderVerificacao()}
                </div>
            </React.Fragment>
        )
    }

    renderDenuncia() {
        if(this.props.value.denuncia == "Sim") {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Protocolo Nº:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="protocolo"
                            {...this.props}
                            value={this.props.value.protocolo} />
                    </div>
                </React.Fragment>
            )
        }
    }

    renderVerificacao() {
        if(this.props.value.verificacao == "de Adequação") {
            return (
                <React.Fragment>
                    <label className="col-3 col-md-2">Processo Adm. Nº:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control"
                            name="processoAdm"
                            {...this.props}
                            value={this.props.value.processoAdm} />
                    </div>
                </React.Fragment>
            )
        }
    }
}